import React, { useEffect, useState } from 'react';
import { formatElapsed } from './utils';

interface ElapsedTimerProps {
  startedAt: number;
  className?: string;
}

// Ticks while a message is still streaming so the "Thinking" loader shows a
// live-updating elapsed time next to it (e.g. "3.4s"). Purely presentational —
// the frozen, final duration is stored on the message itself once it finishes.
export default function ElapsedTimer({ startedAt, className = 'bx-thinking-timer' }: ElapsedTimerProps) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 200);
    return () => clearInterval(id);
  }, []);

  return <span className={className}>{formatElapsed(now - startedAt)}</span>;
}
